import { defineMessages } from 'react-intl-next';

export const messages: {
	defaultBackgroundImageAltText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteImageButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fileUploadButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	fileUploadButtonText: {
		id: 'company-hub.company-hub-common.unsplash.upload.text',
		defaultMessage: 'Upload',
		description:
			'Text for button that opens dialog to be able to select an image from a users computer',
	},
	deleteImageButtonText: {
		id: 'company-hub.company-hub-common.unsplash.delete.image.text',
		defaultMessage: 'Remove image',
		description: 'Text for button that removes the selected image from the media picker',
	},
	defaultBackgroundImageAltText: {
		id: 'company-hub.company-hub-common.unsplash.background-img.default.label',
		defaultMessage: 'Default background image for upload previewer',
		description:
			'Alternative text for the background image in the upload preview section of the media picker',
	},
});
